export const TUTORIAL_GAME_ID = 9999;
export const PRACTICE_GAME_ID_2 = 9998;
export const PRACTICE_GAME_ID_3 = 9997;

const TUTORIAL_SHOWN_KEY = "tutorialHasBeenShown";
const TUTORIAL_DISABLED_KEY = "tutorialDisabled";

export function shouldShowTutorial(numbersPlayed) {
  const hasBeenShown = localStorage.getItem(TUTORIAL_SHOWN_KEY) === "true";
  const isDisabled = localStorage.getItem(TUTORIAL_DISABLED_KEY) === "true";
  // Check if numbersPlayed is 0 or undefined/null
  const playedCount = numbersPlayed || 0;
  return playedCount === 0 && !hasBeenShown && !isDisabled;
}

export function markTutorialAsShown() {
  localStorage.setItem(TUTORIAL_SHOWN_KEY, "true");
}

export function disableTutorialPermanently() {
  localStorage.setItem(TUTORIAL_DISABLED_KEY, "true");
}

export function isTutorialPermanentlyDisabled() {
  return localStorage.getItem(TUTORIAL_DISABLED_KEY) === "true";
}

export function getTutorialLabel(langString) {
  return langString === "nl" ? "Tutorial" : "Tutorial";
}

export function isTutorialGame(idNumber) {
  const num = Number(idNumber);
  return num === TUTORIAL_GAME_ID || num === PRACTICE_GAME_ID_2 || num === PRACTICE_GAME_ID_3;
}
